export default class Constants {
  static END_POINT = {
    // Auth and profile end points
    signup: "auth/signup-email",
    sendOtp: "/auth/email/send-otp",
    verifyOtp: "/auth/email/verify-otp",
    login: "auth/social",
    logout: "user/logout",
    my_profile: "user/me",
    my_role: "user/user-role",
    update_profile: "user/update",
    user_roles: "user/roles",
    update_role: "user/role-update/",

    // mfa
    enableMFA: "auth/mfa/enable",
    disableMFA: "auth/mfa/disable",
    verifyMFA: "auth/mfa/verify",
    validateMFA: "auth/mfa/validate",

    // Profile setup endpoints
    profile_setup_status: "profile-setup/status",
    profile_setup_step1: "profile-setup/step1",
    profile_setup_step2: "profile-setup/step2",
    profile_setup_step3: "profile-setup/step3",
    profile_setup_step4: "profile-setup/step4",
    profile_setup_complete: "profile-setup/complete",
    profile_setup_skip: "profile-setup/skip",

    // Organization end points
    organization: "org/",
    organization_update: "org/update/",

    // Teams and member invitation end points
    team: "team/",
    multiple_team: "team/bulk",
    invite_member: "team/invite-team-member",
    handle_invite: "team/handle-invite",
    invite_details: "team/invite/",
    all_invitations: "team/invitation/",
    myTeams: "team/all/by-user",
    delete_members: "team/team-member/bulk-delete",

    // Settings endpoints
    update_notifications: "settings/notifications",
    update_security_settings: "settings/security",
    change_password: "settings/change-password",
    active_sessions: "settings/active-sessions",
    sign_out_other_sessions: "settings/sign-out-other-sessions",
    update_report_preferences: "settings/report-preferences",
    export_reports: "settings/export-reports",

    // Billing and subscription endpoints
    getPlans: "plans",
    buySubscription: "billing/dualpay/buy-subscription/",
    paymentAction: "billing/payment-action",
    cancelSubscription: "billing/dualpay/cancel-subscription/",
    upgradeSubscription: "billing/dualpay/upgrade-subscription",
    cancelUpgrade: "billing/handle-upgrade-cancel",
    getSubscription: "billing/get-subscription",
    addBillingInfo: "billing/add-billing-info/",
    fetchBillingInfo: "billing/get-billing-info",
    getInvoices: "billing/get-invoices/",
    getUsage: "billing/get-usage",
    getRunningCharges: "billing/get-running-charges/",
    downloadInvoice: "billing/dualpay/get-invoice-detail",
    getPaymentMethods: "billing/payment-methods/org", // List all payment methods
    setDefaultPaymentMethod: "billing/payment-methods/default", // Set default payment method
    deletePaymentMethod: "billing/payment-methods", // Delete payment method
    chargeCard: "billing/check-card/",
    verifyCard: "billing/verify-card/",
    payNow: "billing/dualpay/pay-now/",
    handlePayNow: "billing/handle-pay-now/",

    // Integrations
    integration_auth: "integration/authorize",
    integration_connections: "integration/connections",
    integration_repos: "integration/repositories",
    integration_repo_branches: "integration/branches",

    // Projects
    project: "project/",
    project_list: "project/all",
    project_analytics: "project/analytics/",
    project_availability: "project/check-name-availability?name=",
    project_deploy: "project/deploy",
    project_update: "project/update/",
    project_name_update: "project/name/update/",
    project_deploy_latest: "project/latest-commit-deploy",
    project_single: "project/single/",
    project_deployment: "project/deployment/",
    project_deployment_status: "project/deployment/status/",
    project_deploy_specific_commit: "project/commit/deploy",
    project_redirect_rules: "project/redirects/update/",
    project_headers: "project/headers/update/",

    // Projects Misc
    custom_domain: "custom-domain/",
    redirects: "redirects/",
    header: "header/",
    events: "events/",
    monitors: "monitors/",
    analytics: "analytics/project/",

    // Configuration
    configuration: "configurations/",
    getConfigurations: "configurations",

    // Panda Edge Function
    functions: "functions",

    // Edge Functions
    edge: "edge/",
    edge_create: "edge/create",
    edge_update: "edge/update/",
    edge_delete: "edge/delete/",
    edge_logs: "edge/:id/logs",
    edge_metrics: "edge/:id/metrics",
    edge_test: "edge/:id/test",
    edge_endpoint: "edge/:id/endpoint",
    edge_auth: "edge-auth",
    edge_check_name: "edge/name/check",
    edge_versions: "edge/:id/versions",
    edge_rollback: "edge/:id/rollback",

    // SSO end points
    sso: "sso/",
    sso_single: "sso/single/",
    sso_update: "sso/update/",

    // Managed Apps
    managedApps: "managed-apps/",
    managedApps_deploy: "managed-apps/deploy",
    managedApps_update: "managed-apps/update/",
    managedApps_delete: "managed-apps/delete/",
    managedApps_list: "managed-apps/",
    managedApps_status: "managed-apps/status",
    managedApps_check_name: "managed-apps/check-name",
    managed_app_custom_domain: "managed-app-custom-domain",

    // Database endpoints
    dataBaseDeployment: "database",
    getDeployedDatabaseLogs: "database/getDeployedDatabaseLogs",
    database_deployment_status: "database/status",
    deleteDatabase: "database/",
    getAllDatabaseDeployments: "database",
    database_metrics: "database/:id/metrics",
    database_users: "database/:id/users",
    database_access_logs: "database/:id/access-logs",
    database_query_analytics: "database/:id/query-analytics",
    database_ssl: "database/:id/ssl",
    database_backups: "database/:id/backups",
    database_backup_settings: "database/:id/backup",
    database_restore: "database/:id/restore",
    database_user_access: "database/:id/users",
    database_connection_string: "database/:id/connection",
    database_topology: "database/:id/topology",

    // AI endpoints
    ai_chat: "ai/chat",

    // User Settings
    user_settings_change_password: "user-settings/change-password",

    // Settings
    ApiToken: "/functions/tokens",
    getUserDetails: "/user/me",
    updateUser: "/user/update",
  };

  static PROFILE_SETUP_STEPS = [
    { label: "Basic Information", icon: "pi pi-user" },
    { label: "Professional Details", icon: "pi pi-briefcase" },
    { label: "Organization", icon: "pi pi-building" },
    { label: "Plan Selection", icon: "pi pi-credit-card" },
    { label: "Complete", icon: "pi pi-check" },
  ];

  static COMPANY_SIZES = [
    { label: "1-10", value: "1-10" },
    { label: "11-50", value: "11-50" },
    { label: "51-200", value: "51-200" },
    { label: "201-500", value: "201-500" },
    { label: "501-1000", value: "501-1000" },
    { label: "1000+", value: "1000+" },
  ];

  static INDUSTRIES = [
    { label: "Technology", value: "Technology" },
    { label: "Healthcare", value: "Healthcare" },
    { label: "Finance", value: "Finance" },
    { label: "Education", value: "Education" },
    { label: "Manufacturing", value: "Manufacturing" },
    { label: "Retail", value: "Retail" },
    { label: "Other", value: "Other" },
  ];

  // Hetzner server options for V2 deployments
  static HETZNER_SERVERS = [
    {
      label: 'PS-01',
      value: 'cpx11',
      category: 'hetzner',
      specs: { cpu: 2, ram: 2048, disk: 40960 },
      price: 0.0104,
    },
    {
      label: 'PS-02',
      value: 'cpx21',
      category: 'hetzner',
      specs: { cpu: 3, ram: 4096, disk: 81920 },
      price: 0.0207,
    },
    {
      label: 'PS-03',
      value: 'cpx31',
      category: 'hetzner',
      specs: { cpu: 4, ram: 8192, disk: 163840 },
      price: 0.0415,
    },
    {
      label: 'PS-04',
      value: 'cpx41',
      category: 'hetzner',
      specs: { cpu: 8, ram: 16384, disk: 245760 },
      price: 0.0829,
    },
    {
      label: 'PS-05',
      value: 'cpx51',
      category: 'hetzner',
      specs: { cpu: 16, ram: 32768, disk: 368640 },
      price: 0.1659,
    }
  ];

  // List of apps that support environment variables
  static APPS_WITH_ENV_VARS = ['strapi', 'consul', 'directus', 'supabase', 'keycloak', 'vault', 'gitlab', 'clickhouse', 'elasticsearch', 'rabbitmq', 'odoo'];
}
